import React, { useState } from 'react';
import { Skeleton, Row, Col, Carousel , Spin,List,Avatar,Tabs,Modal} from 'antd';
import NavbarButton from '../NavbarButton';
import Permission from '../Permission';
import Roles from '../Permission/Roles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BicycleParkingSpotCard } from './BicycleParkingSpotCard';
import './BicycleParkingSpotInfo.css';
import { config } from '../../config';
import SurveyVerification from '../AdministrationInterface/SurveyVerification';
const { TabPane } = Tabs;
export const BicycleParkingSpotMoreInfo = ({bicycleParkingSpot,setShowBicycleParkingVisible,onEditLocation, ...otherProps}) => {   
    const[showVerificationInterface,setShowVerificationInterface]=useState(false)
    if(!bicycleParkingSpot) {
        return <Skeleton active />;
    }
    const toggleshowVerificationInterface = () =>{
		setShowVerificationInterface(!showVerificationInterface);
	}
    let details=bicycleParkingSpot[0].details

    return (
        
        <>
           
                <Row className='bicycleParkingSpotInfoCenter'>
                    <Col >
                         {!details && <div style={{alignItems:'center', justifyContent:'center', display:'flex', marginTop:20}}><Spin size="large" /></div> || null}
                            {details && (<>

                        {details.photo_alternative_demand&&<img className='bicycleParkingSpotInfoImage' src={`${config.url}${details.photo_alternative_demand}`}></img>}
                        {details.photo_existing_demand && <img className='bicycleParkingSpotInfoImage' src={`${config.url}${details.photo_existing_demand}`}></img>}
                        {details.photo && <img className='bicycleParkingSpotInfoImage' src={`${config.url}${details.photo}`}></img>}
                        <p className='divider'></p>

                        {details.bicycle_stand_type && <p>Tip stalka: <strong>{details.bicycle_stand_type}</strong></p>}
                        {details.bicycle_stand_capacity &&(<>
                        {(details.bicycle_stand_capacity.theoretical||details.bicycle_stand_capacity.theoretica=='0')&&<p>Teorijski kapacitet: <strong>{details.bicycle_stand_capacity.theoretical}</strong></p>}    
                        {(details.bicycle_stand_capacity.real||details.bicycle_stand_capacity.real=='0')&&<p>Realni kapacitet: <strong>{details.bicycle_stand_capacity.real}</strong></p> }
                        </>)}
                        {details.cover_type&&<p>Status naktrivenosti: <strong>{details.cover_type}</strong></p> }                        
                        {details.status_fastened_to_ground&&<p>Status učvrščenosti za tlo: <strong>{details.status_fastened_to_ground}</strong></p> }
                        {details.status_way_of_binding&&<><p>Status stalka s obzirom na način vezivanja bicikla za stalak:<br/><strong>{details.status_way_of_binding}</strong></p> </>}                        
                        {details.preservation_adequacy_status&&<p>Status adekvatnosti s obzirom na očuvanost : <strong>{details.preservation_adequacy_status}</strong></p> }
                        {details.functionality_status&&<p>Status adekvatnosti s obzirom na funkcionalnost: <strong>{details.functionality_status}</strong></p> }
                        {details.bicycle_stand_purpose&&<p>Vrsta najbližeg objekta: <strong>{details.bicycle_stand_purpose!="other"&&details.bicycle_stand_purpose||"ostalo"}</strong></p> }                        
                        


                        {details.type_of_demand && <p>Vrsta potražnje: <strong>{details.type_of_demand}</strong></p>}
                        {details.bicycle_stand_type_demand && <p>Tip stalka: <strong>{details.bicycle_stand_type_demand}</strong></p>}
                        {details.cover_type_demand&&<p>Status naktrivenosti: <strong>{details.cover_type_demand}</strong></p> }
                        {details.bicycle_stand_capacity_demand &&(<>
                        {details.bicycle_stand_capacity_demand.theoretical&&<p>Teorijski kapacitet: <strong>{details.bicycle_stand_capacity_demand.theoretical}</strong></p>}    
                        {details.bicycle_stand_capacity_demand.real&&<p>Realni kapacitet: <strong>{details.bicycle_stand_capacity_demand.real}</strong></p> }
                        </>)}                        
                        {details.parking_reason_demand&&<p>Svrha dolaska i parkiranja na lokaciju: <br/><strong>{details.parking_reason_demand}</strong></p> }
                        {details.time_of_stay_demand&&<p>Vrijeme zadržavanja: <strong>{details.time_of_stay_demand}</strong></p> }
                        {details.frequency_of_stay_demand&&<p>Koliko često je potrebno odložiti prijevozno sredstvo na lokaciju: <br/><strong>{details.frequency_of_stay_demand}</strong></p> }
                        {details.cover_type_if_exists_demand&&<p>Postoji li parkirališni kapacitet na lokaciji: <strong>{details.cover_type_if_exists_demand}</strong></p> }
                        {details.questionee_reason_for_no_usage_demand&&<p>Razlog zbog kojeg se ne koristi postojeći parkirališni kapacitet: <strong>
                            {details.questionee_reason_for_no_usage_demand.map(reason=><li>{reason}</li>)} 
                        </strong></p> }
                        {details.important_improvement_element_demand&&<p>Najvažniji elementi unaprijeđenja: 
                            <strong>
                                {details.important_improvement_element_demand.map(element=>                                    
                                    <li>{element}</li>                                    
                                    )}                            
                            </strong></p> }
                        </>)}

                        {details.status_fastened_to_ground=='učvršćen za tlo ili objekt'&&details.status_way_of_binding=='moguće vezivanje bicikla za okvir (ramu)'&&
                        <p><strong>Usklađen s Pravilnikom o biciklističkoj infrastrukturi</strong></p>||
                        details.status_fastened_to_ground&&details.status_way_of_binding&&
                        <p><strong>Neusklađen s Pravilnikom o biciklističkoj infrastrukturi</strong></p>
                        }         

                    </Col> 
                </Row> 
            
            <Permission roles={[Roles.Admin,Roles.Verifikator]}>
            <div>                
                <NavbarButton title="Edit"  onClick={toggleshowVerificationInterface} style={{color:'red',marginLeft:'180px'}}icon="ri-edit-2-fill" />            
                <NavbarButton onClick={(e)=>{setShowBicycleParkingVisible();onEditLocation(bicycleParkingSpot[0].id)}}  style={{color:'yellow',marginLeft:'40px'}}icon="ri-map-pin-2-line" />
            </div>		
            </Permission>
            <Modal
				centered 
				width="100%"
				visible={showVerificationInterface}
				onCancel={toggleshowVerificationInterface}
				className={"administrationInterfaceModal"}
				footer={false}
			>
					<SurveyVerification
                    id={bicycleParkingSpot[0].id}
                    details={bicycleParkingSpot[0].details}
                    idcontrols={bicycleParkingSpot[0].idcontrols}
                    bicycleParkingSpot={bicycleParkingSpot}
                    editVerifiedSurvey={true}
                    setShowVerificationInterface={setShowVerificationInterface}
                    onDataUpdate={otherProps.onDataUpdate}
                    setShowBicycleParkingVisible={setShowBicycleParkingVisible}
                    ></SurveyVerification>
				
			</Modal>	
        </>
    )
    }